
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexidyDttn2nAtfyKcnzRUSqhwnL7kztssg1Rdvj0_45dfSAMeta } from "/workspace/pages/index.vue?macro=true";
import { default as priserbtyg0mvWQwA3ctBe22AJjIDtYg9reH_45fGt4wmwF2ktAMeta } from "/workspace/pages/priser.vue?macro=true";
import { default as ansatteIe81cVtc2JPU_45fdHzijB0kHeFhMB6_45uJ_plsfQtQLw4Meta } from "/workspace/pages/ansatte.vue?macro=true";
import { default as kontaktdo94YlvSVAXRtL7_45mctFPDENZIO_456iuSagwdy8hZ6xcMeta } from "/workspace/pages/kontakt.vue?macro=true";
import { default as tjenesterJSozBOLRvC6YXT_BUFfnwpPeycz_45pX2RXqeo56u0dusMeta } from "/workspace/pages/tjenester.vue?macro=true";
import { default as index0XIr1CuQ4fmUwegYLTCj1Obxg1a4h2k1TPEz8ucq9TEMeta } from "/workspace/pages/admin/index.vue?macro=true";
import { default as linksApCokYFl5VhTlhnT42WDb1tKDUqYRwqP4njuw9XWizcMeta } from "/workspace/pages/admin/links.vue?macro=true";
import { default as loginD5xG7U3olPpeQoS4jLmOy3Ith3qH8Gn_sVREUbbz4pcMeta } from "/workspace/pages/admin/login.vue?macro=true";
import { default as priserZLhhGl41ASflumT17Vn33f2MYp1Fd0eoPFmxZ8msJk8Meta } from "/workspace/pages/admin/priser.vue?macro=true";
import { default as apningstiderVTiTiVq1lroAKotn_0_45yJknJGEiruq2ijvn_45MBUrEfMMeta } from "/workspace/pages/apningstider.vue?macro=true";
import { default as ansatteYLucYZie7t4ZK9OQ6DgLtb9O5TPInmMZOERhX9ldYZ0Meta } from "/workspace/pages/admin/ansatte.vue?macro=true";
import { default as kontakt4zARZOx30QZttljOmDStxnbQ3Sr44Jtxnza0lbITbHAMeta } from "/workspace/pages/admin/kontakt.vue?macro=true";
import { default as nyheterV6ZqbzPutwgnOjzyKnHJ3x7jdOJ9JbHtu0nNuMurti4Meta } from "/workspace/pages/admin/nyheter.vue?macro=true";
import { default as openinghoursCWiQ3_E8g3iQrxqoilLDqOD6A8_9T5rznmkgUg8gqZwMeta } from "/workspace/pages/admin/openinghours.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/workspace/pages/index.vue")
  },
  {
    name: "priser",
    path: "/priser",
    component: () => import("/workspace/pages/priser.vue")
  },
  {
    name: "ansatte",
    path: "/ansatte",
    component: () => import("/workspace/pages/ansatte.vue")
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/workspace/pages/kontakt.vue")
  },
  {
    name: "tjenester",
    path: "/tjenester",
    component: () => import("/workspace/pages/tjenester.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index0XIr1CuQ4fmUwegYLTCj1Obxg1a4h2k1TPEz8ucq9TEMeta || {},
    component: () => import("/workspace/pages/admin/index.vue")
  },
  {
    name: "admin-links",
    path: "/admin/links",
    meta: linksApCokYFl5VhTlhnT42WDb1tKDUqYRwqP4njuw9XWizcMeta || {},
    component: () => import("/workspace/pages/admin/links.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: loginD5xG7U3olPpeQoS4jLmOy3Ith3qH8Gn_sVREUbbz4pcMeta || {},
    component: () => import("/workspace/pages/admin/login.vue")
  },
  {
    name: "admin-priser",
    path: "/admin/priser",
    meta: priserZLhhGl41ASflumT17Vn33f2MYp1Fd0eoPFmxZ8msJk8Meta || {},
    component: () => import("/workspace/pages/admin/priser.vue")
  },
  {
    name: "apningstider",
    path: "/apningstider",
    component: () => import("/workspace/pages/apningstider.vue")
  },
  {
    name: "admin-ansatte",
    path: "/admin/ansatte",
    meta: ansatteYLucYZie7t4ZK9OQ6DgLtb9O5TPInmMZOERhX9ldYZ0Meta || {},
    component: () => import("/workspace/pages/admin/ansatte.vue")
  },
  {
    name: "admin-kontakt",
    path: "/admin/kontakt",
    meta: kontakt4zARZOx30QZttljOmDStxnbQ3Sr44Jtxnza0lbITbHAMeta || {},
    component: () => import("/workspace/pages/admin/kontakt.vue")
  },
  {
    name: "admin-nyheter",
    path: "/admin/nyheter",
    meta: nyheterV6ZqbzPutwgnOjzyKnHJ3x7jdOJ9JbHtu0nNuMurti4Meta || {},
    component: () => import("/workspace/pages/admin/nyheter.vue")
  },
  {
    name: "admin-openinghours",
    path: "/admin/openinghours",
    meta: openinghoursCWiQ3_E8g3iQrxqoilLDqOD6A8_9T5rznmkgUg8gqZwMeta || {},
    component: () => import("/workspace/pages/admin/openinghours.vue")
  }
]